import api from '@/services/axios';

export async function fetchNotifications(params = {}) {
  const response = await api.get('/notifications', { params });
  return response.data || {};
}

export async function fetchUnreadCount() {
  const response = await api.get('/notifications/unread_count');
  return response.data || {};
}

export async function markNotificationRead(notificationId) {
  const response = await api.patch(`/notifications/${notificationId}/read`);
  return response.data || {};
}

export async function markAllNotificationsRead() {
  const response = await api.patch('/notifications/read-all');
  return response.data || {};
}
